import api from '@/services/api'

const state = {
    user: null,
    token: localStorage.getItem('token'),
    isAuthenticated: !!localStorage.getItem('token')
}

const mutations = {
    SET_USER(state, user) {
        state.user = user
    },
    SET_TOKEN(state, token) {
        state.token = token
        state.isAuthenticated = !!token
        if (token) {
            localStorage.setItem('token', token)
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        } else {
            localStorage.removeItem('token')
            delete api.defaults.headers.common['Authorization']
        }
    },
    LOGOUT(state) {
        state.user = null
        state.token = null
        state.isAuthenticated = false
        localStorage.removeItem('token')
        delete api.defaults.headers.common['Authorization']
    }
}

const actions = {
    async login({ commit }, credentials) {
        try {
            const response = await api.post('/auth/login', credentials)
            const { token, user } = response.data

            commit('SET_TOKEN', token)
            commit('SET_USER', user)

            return { success: true, user }
        } catch (error) {
            const message = error.response?.data?.error || 'Login failed'
            return { success: false, error: message }
        }
    },

    async logout({ commit }) {
        commit('LOGOUT')
    },

    async checkAuth({ commit, state }) {
        if (state.token) {
            try {
                // Set token in headers
                api.defaults.headers.common['Authorization'] = `Bearer ${state.token}`

                // Verify token is still valid and get user data
                const response = await api.get('/auth/me')

                // If successful, token is valid and we have user data
                commit('SET_USER', response.data.user)
                return true
            } catch (error) {
                // Token is invalid
                commit('LOGOUT')
                return false
            }
        }
        return false
    },

    async fetchCurrentUser({ commit, state }) {
        if (state.token) {
            try {
                api.defaults.headers.common['Authorization'] = `Bearer ${state.token}`
                const response = await api.get('/auth/me')
                commit('SET_USER', response.data.user)
                return { success: true, user: response.data.user }
            } catch (error) {
                const message = error.response?.data?.error || 'Failed to fetch user data'
                return { success: false, error: message }
            }
        }
        return { success: false, error: 'No token available' }
    }
}

const getters = {
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    token: state => state.token,
    isAdmin: state => state.user?.is_admin || false
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}